module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido@2x-c2a3330b8b8249ca922fcbd57f54619b.jpg";